var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.580959 8.9374C0.0928059 9.42556 0.0928058 10.217 0.580959 10.7052L8.53591 18.6601C9.02407 19.1483 9.81552 19.1483 10.3037 18.6601C10.7918 18.172 10.7918 17.3805 10.3037 16.8924L3.23261 9.82129L10.3037 2.75022C10.7918 2.26206 10.7918 1.47061 10.3037 0.982453C9.81552 0.494298 9.02407 0.494298 8.53591 0.982453L0.580959 8.9374ZM21.7148 8.57129L1.46484 8.57129L1.46484 11.0713L21.7148 11.0713L21.7148 8.57129Z",
    fill: "#547AFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.6d7dc33ca3700bccae05fa792d82302d.svg";
export { ForwardRef as ReactComponent };